import config from "../app-config.js";
const { default: serverFetch } = require("../utils/serverFetch.js");

export const fetch_event_registration_by_event_id = async (event_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/events/registration/event/id/${event_id}`,
    }))
}

export const event_export_registration_data_by_event_id = async (event_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/events/export/participants/${event_id}`,
    }))
}

export const delete_child_registration_from_session = async (child_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/events/registration/session/group/child/id/${child_id}`,
        method: "DELETE"
    }))
}

export const fetch_checkin_sessions_by_event_id = async (event_id) => {
    if (!event_id) return { error: 'No event id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/checkin/session/event/id/${event_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

export const fetch_event_participants_by_event_id = async (event_id) => {
    if (!event_id) return { error: 'No event id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/participants/event/id/${event_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

export const fetch_group_registration_by_group_id = async (group_id) => {
    if (!group_id) return { error: 'No group id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/registration/group/id/${group_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

export const update_registration_by_id = async (registration_id, registrationData) => {
    if (!registration_id) return { error: 'No registration id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/registration/id/${registration_id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(registrationData),
        credentials: 'include'
    })
}

export const update_group_registration_by_group_id = async (group_id, groupData) => {
    if (!group_id) return { error: 'No group id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/registration/group/id/${group_id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(groupData),
        credentials: 'include'
    })
}

export const fetch_registration_by_id = async (registration_id) => {
    if (!registration_id) return { error: 'No registration id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/registration/id/${registration_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

// Checkin session endpoints
export const fetch_checkin_session_by_id = async (session_id) => {
    if (!session_id) return { error: 'No session id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/checkin/session/id/${session_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

export const create_checkin_session = async (sessionData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/events/checkin/session/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sessionData),
        credentials: 'include'
    })
}

export const update_checkin_session = async (session_id, sessionData) => {
    if (!session_id) return { error: 'No session id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/checkin/session/id/${session_id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sessionData),
        credentials: 'include'
    })
}

export const delete_checkin_session = async (session_id) => {
    if (!session_id) return { error: 'No session id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/checkin/session/id/${session_id}`,
        method: 'DELETE',
        credentials: 'include'
    })
}

export const fetch_checkin_participants_by_session_id = async (session_id) => {
    if (!session_id) return { error: 'No session id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/checkin/participants/session/id/${session_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

// Accommodations and forms
export const fetch_event_accommodations_by_event_id = async (event_id) => {
    if (!event_id) return { error: 'No event id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/accommodations/id/${event_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

export const update_event_forms = async (formData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/events/forms/`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
        credentials: 'include'
    })
}

export const fetch_event_forms_by_event_id = async (event_id) => {
    if (!event_id) return { error: 'No event id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/forms/id/${event_id}`,
        method: 'GET',
        credentials: 'include'
    })
}


export const fetch_all_events = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/events/`,
        method: "GET",
        credentials: "include"
    });
}

export const duplicate_event = async ({ event_id }) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/events/duplicate`,
        method: "POST",
        credentials: "include",
        body: JSON.stringify({ event_id })
    });
}

export const fetch_event_by_id = async (event_id) => {
    if (!event_id) return { error: "No event id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/id/${event_id}`,
        method: "GET",
        credentials: "include"
    });
}

export const create_new_event = async (event_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/events/`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(event_data),
        credentials: "include"
    });
}

export const update_event_by_id = async (event_id, event_data) => {
    if (!event_id) return { error: "No event id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/id/${event_id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(event_data),
        credentials: "include"
    });
}

export const delete_event_by_id = async (event_id) => {
    if (!event_id) return { error: "No event id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/events/id/${event_id}`,
        method: "DELETE",
        credentials: "include"
    });
}